export default {"src":"/_next/static/media/enforce-access-controls.f6314966.svg","height":804,"width":844,"blurWidth":0,"blurHeight":0};